import { render, staticRenderFns } from "./BatchPaymentDialog.vue?vue&type=template&id=546a74bb&scoped=true"
import script from "./BatchPaymentDialog.vue?vue&type=script&lang=js"
export * from "./BatchPaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchPaymentDialog.vue?vue&type=style&index=0&id=546a74bb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a74bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546a74bb')) {
      api.createRecord('546a74bb', component.options)
    } else {
      api.reload('546a74bb', component.options)
    }
    module.hot.accept("./BatchPaymentDialog.vue?vue&type=template&id=546a74bb&scoped=true", function () {
      api.rerender('546a74bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/BatchPaymentDialog.vue"
export default component.exports